import React from 'react'
import moment from 'moment'
import _ from 'lodash'
import { Icon, Div } from 'konsys-ui'
import { Tooltip } from 'antd'
import { ChevronsUpDown } from 'lucide-react'
import {
  InputWithPlaceHolder, ActionSelector, HeaderLabel, CellText, DropdownSelector, CustomerActionSelector,
} from '../../../components/job-components'
import { theme } from '../../../styles/_variables'

const { color } = theme

export default {
  columns: [{
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          เริ่มอายุสัญญา <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'contractStart',
    sortable: true,
    filterable: false,
    Cell: props => <CellText textAlign='center'>{props.value ? moment(props.value).format('DD/MM/YY') : '' }</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.contractStart, filter.value),
    width: 120,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          เลขที่ <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'number',
    sortable: true,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText textAlign='center'>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.number, filter.value),
    width: 200,
  }, {
    Header: () => <HeaderLabel>ผู้จ้าง</HeaderLabel>,
    accessor: 'Customer.companyName',
    sortable: false,
    filterable: true,
    width: 300,
    Cell: props => (
      <Tooltip placement="top" title={props.value}>
        <CellText textAlign='center'>{props.value}</CellText>
      </Tooltip>
    ),
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.Customer.companyName, filter.value),
  }, {
    Header: () => <HeaderLabel>ประเภทสินค้า</HeaderLabel>,
    accessor: 'cargo',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText textAlign='center'>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.cargo, filter.value),
    width: 150,
  }, {
    Header: <HeaderLabel>น้ำหนักทั้งหมด</HeaderLabel>,
    accessor: 'contractWeight',
    sortable: false,
    filterable: false,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    width: 110,
  }, {
    Header: <HeaderLabel>น้ำหนัก/เที่ยวที่ขนส่งแล้ว</HeaderLabel>,
    accessor: 'deliveredWeight',
    sortable: false,
    filterable: false,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    width: 150,
  }, {
    Header: <HeaderLabel>ประเภทสัญญางาน</HeaderLabel>,
    accessor: 'dealType',
    sortable: false,
    filterable: true,
    Filter: ({ onChange }) => <DropdownSelector
      key='filter'
      data={[{ value: 'ALL', text: 'ทั้งหมด' }, { value: 'PERWEIGHT', text: 'ต่อน้ำหนัก' }, { value: 'PERTRIP', text: 'ต่อเที่ยว' }]}
      handleChange={e => onChange(e)}
      filter={true}
      statusAttr='ทั้งหมด'
    />,
    filterMethod: (filter, row) => _.includes(row.Customer.typeOfCharge, filter.value),
    Cell: props => <CellText textAlign='center'>{props.value === 'PERWEIGHT' ? 'ต่อน้ำหนัก' : 'ต่อเที่ยว'}</CellText>,
    width: 130,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector disabled={props.tdProps.rest.disabled} id={props.original.id} isExpired={moment(props.original.contractEnd).isBefore()}/>,
    width: 150,
  }],
  customerColumns: [{
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          เริ่มอายุสัญญา <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'contractStart',
    sortable: true,
    filterable: false,
    Cell: props => <CellText textAlign='center'>{props.value ? moment(props.value).format('DD/MM/YY') : '' }</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.contractStart, filter.value),
    width: 120,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          เลขที่ <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'number',
    sortable: true,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText textAlign='center'>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.number, filter.value),
    width: 200,
  }, {
    Header: () => <HeaderLabel>ผู้จ้าง</HeaderLabel>,
    accessor: 'Customer.companyName',
    sortable: false,
    filterable: true,
    width: 300,
    Cell: props => (
      <Tooltip placement="top" title={props.value}>
        <CellText textAlign='center'>{props.value}</CellText>
      </Tooltip>
    ),
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.Customer.companyName, filter.value),
  }, {
    Header: () => <HeaderLabel>ประเภทสินค้า</HeaderLabel>,
    accessor: 'cargo',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText textAlign='center'>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.cargo, filter.value),
    width: 150,
  }, {
    Header: <HeaderLabel>น้ำหนักทั้งหมด</HeaderLabel>,
    accessor: 'contractWeight',
    sortable: false,
    filterable: false,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    width: 110,
  }, {
    Header: <HeaderLabel>น้ำหนัก/เที่ยวที่ขนส่งแล้ว</HeaderLabel>,
    accessor: 'deliveredWeight',
    sortable: false,
    filterable: false,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    width: 150,
  }, {
    Header: <HeaderLabel>ประเภทสัญญางาน</HeaderLabel>,
    accessor: 'dealType',
    sortable: false,
    filterable: true,
    Filter: ({ onChange }) => <DropdownSelector
      key='filter'
      data={[{ value: 'ALL', text: 'ทั้งหมด' }, { value: 'PERWEIGHT', text: 'ต่อน้ำหนัก' }, { value: 'PERTRIP', text: 'ต่อเที่ยว' }]}
      handleChange={e => onChange(e)}
      filter={true}
      statusAttr='ทั้งหมด'
    />,
    filterMethod: (filter, row) => _.includes(row.Customer.typeOfCharge, filter.value),
    Cell: props => <CellText textAlign='center'>{props.value === 'PERWEIGHT' ? 'ต่อน้ำหนัก' : 'ต่อเที่ยว'}</CellText>,
    width: 130,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <CustomerActionSelector disabled={props.tdProps.rest.disabled} id={props.original.id} isExpired={moment(props.original.contractEnd).isBefore()}/>,
    width: 150,
  }],
}
